import { Grid, Text, Flex, Avatar } from '@backstage/ui';
import { useUserProfile } from '@backstage/plugin-user-settings';
import { AppearanceCard, AuthCard } from './components';
import styles from './settings.module.css';

const ProfileHero = () => {
  const { profile, displayName, loading } = useUserProfile();

  if (loading) return null;

  return (
    <div className={styles.profileHero}>
      <div className={styles.profileContent}>
        <div className={styles.avatarWrap}>
          <Avatar
            name={displayName}
            src={profile.picture || ''}
            size="large"
          />
        </div>
        <div className={styles.profileInfo}>
          <Text variant="title-small" weight="bold">
            {displayName}
          </Text>
          {profile.email && (
            <Text variant="body-small" className={styles.profileEmail}>
              {profile.email}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

export const SettingsPage = () => {
  return (
    <Flex direction="column" gap="4" className={styles.page}>
      <ProfileHero />
      <Grid.Root columns="12" gap="4">
        <Grid.Item colSpan={{ xs: '12', md: '7' }}>
          <AppearanceCard />
        </Grid.Item>
        <Grid.Item colSpan={{ xs: '12', md: '5' }}>
          <AuthCard />
        </Grid.Item>
      </Grid.Root>
    </Flex>
  );
};
